// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface ZoomConfigOut {}

export const ZoomConfigOutSerializer = {
  _fromJsonObject(_object: any): ZoomConfigOut {
    return {};
  },

  _toJsonObject(_self: ZoomConfigOut): any {
    return {};
  },
};
